module.exports = __webpack_public_path__ + "img/retired-2015-spring.d21fd69a.jpg";